const TYPES = ({

  // list
  loadingFormSearch: 'LOADING_SEARCH_SETTINGS_SERVICE_STATUS_FORM_TOGGLE',
  searchSuccess: 'SEARCH_SETTINGS_SERVICE_STATUS_SUCCESS',
  searchError: 'SEARCH_SETTINGS_SERVICE_STATUS_LIST_ERROR',

  // form create
  updateItemListingManagerSuccess: 'MANAGER_SETTINGS_SERVICE_STATUS_SUCCESS_UPDATE_LISTING',
  insertItemListingManagerSuccess: 'MANAGER_SETTINGS_SERVICE_STATUS_SUCCESS_INSERT_LISTING',
  deleteItemListingManagerSuccess: 'MANAGER_SETTINGS_SERVICE_STATUS_SUCCESS_DELETE_LISTING',

  // form search
  setDefaultPage: 'SET_SEARCH_SETTINGS_SERVICE_STATUS_DEFAULT_PAGE',
});

export default TYPES;
